import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { JourneyService } from '@core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Chatbot, DEFAULT_SESSION_CHAT_SETTINGS } from '../../../classes/chatbot';

function contextValidator(formGroup: AbstractControl): ValidationErrors | null {
  if (
    (formGroup.get('paramKey').value && !formGroup.get('paramValue').value) ||
    (!formGroup.get('paramKey').value && formGroup.get('paramValue').value)
  ) {
    return { paramRequired: true };
  }
  return null;
}
@Component({
  selector: 'app-chat-settings-modal',
  templateUrl: './chat-settings-modal.component.html',
  styleUrls: ['./chat-settings-modal.component.scss'],
})
export class ChatSettingsModalComponent implements OnInit {
  @Input() botSession: Chatbot;

  settingsForm = this.fb.group<{
    customData: FormArray<FormGroup<any>> | FormArray<FormControl<unknown>>;
    parametersMap: FormArray<FormControl<unknown>>;
    contexts: FormArray<FormControl<unknown>>;
    translateResult: FormControl<boolean>;
    selectedLanguage: FormControl<string>;
    journeyCode?: FormControl<string>;
  }>({
    customData: this.fb.array([]),
    parametersMap: this.fb.array([]),
    contexts: this.fb.array([]),
    translateResult: this.fb.control(false),
    selectedLanguage: this.fb.control('', Validators.required),
  });

  get sessionData() {
    return this.settingsForm.get('customData') as FormArray;
  }
  get parametersMap() {
    return this.settingsForm.get('parametersMap') as FormArray;
  }

  get contexts() {
    return this.settingsForm.get('contexts') as FormArray;
  }

  getContextForm(removeOnSubmit = false, name = '', lifespan = '', paramKey = '', paramValue = '') {
    return this.fb.group(
      {
        removeOnSubmit: [removeOnSubmit, Validators.required],
        name: [name, Validators.required],
        lifespan: [lifespan, Validators.required],
        paramKey: [paramKey],
        paramValue: [paramValue],
      },
      { validators: contextValidator }
    );
  }

  getParamForm(removeOnSubmit = false, key = '', value = '') {
    return this.fb.group({
      key: [key, Validators.required],
      value: [value, Validators.required],
      removeOnSubmit: [removeOnSubmit, Validators.required],
    });
  }
  settingsSubmitted = false;
  agentSubscription;
  test:Subscription;
  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private journeyService: JourneyService) {}

  ngOnInit() {

    this.settingsForm.patchValue({
      translateResult: this.botSession.translateResult,
      selectedLanguage: this.botSession.sessionLang,
    });

    this.processFormArray(this.botSession);

  }

  processFormArray(settings) {
    this.settingsForm.setControl(
      'customData',
      this.fb.array(Object.keys(settings.sessionUserData).map((key) => this.getParamForm(false, key, settings.sessionUserData[key])))
    );
    this.settingsForm.setControl(
      'parametersMap',
      this.fb.array(settings.parametersMap.map((p) => this.getParamForm(p.removeOnSubmit, p.key, p.value)))
    );
    this.settingsForm.setControl(
      'contexts',
      this.fb.array(settings.contexts.map((c) => this.getContextForm(c.removeOnSubmit, c.name, c.lifespan, c.paramKey, c.paramValue)))
    );
  }

  resetSettings() {
    this.processFormArray(DEFAULT_SESSION_CHAT_SETTINGS);
  }

  saveSettings(refreshChat) {
    this.settingsSubmitted = true;

    if (this.settingsForm.invalid) return;

    const sessionSettings = {
      sessionUserData: this.sessionData.value.reduce((acc, d) => ({ ...acc, [d.key]: d.value }), {}),
      parametersMap: this.parametersMap.value,
      contexts: this.contexts.value,
      translateResult: this.settingsForm.get('translateResult').value,
      sessionLang: this.settingsForm.get('selectedLanguage').value,
      journeyCode: this.settingsForm.get('journeyCode') ? this.settingsForm.get('journeyCode').value : null,
    };

    this.activeModal.close();
    if (refreshChat) {
      this.botSession.restoreChatbot(sessionSettings);
    } else {
      this.botSession.setSettings(sessionSettings);
    }
  }
}
